import {ReactComponent as DividerVerticalInternal} from './bg-vertical.svg';
function DividerVertical({ num }) {
  return (
    <DividerVerticalInternal className={`Divider-vertical Divider-vertical-${num}`}/>
  )
}
export default DividerVertical